import { Lock, FlaskConical, HeartHandshake, Compass } from "lucide-react";
import { Overline, Reveal } from "./Reveal";

const ITEMS = [
  {
    icon: Lock,
    title: "Sigilo e ética",
    text: "Tudo o que é compartilhado em sessão é protegido pelo sigilo profissional, garantido pelo Código de Ética do Psicólogo.",
  },
  {
    icon: FlaskConical,
    title: "Baseado em evidências",
    text: "Uma prática fundamentada na Terapia Sistêmica Familiar e em conhecimento científico atualizado.",
  },
  {
    icon: HeartHandshake,
    title: "Escuta sem julgamentos",
    text: "Um espaço seguro e acolhedor, onde sua história é recebida com respeito — no seu tempo, do seu jeito.",
  },
  {
    icon: Compass,
    title: "Construção conjunta",
    text: "O processo é construído junto com você, com espaço para ajustar o percurso sempre que necessário.",
  },
];

export const Commitments = () => (
  <section
    data-testid="commitments-section"
    className="border-y border-bark/8 bg-bone/60 py-24 lg:py-28"
  >
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <Overline>O que você pode esperar</Overline>
        <h2 className="mt-6 max-w-2xl font-serif text-3xl font-normal leading-tight tracking-tight text-bark sm:text-4xl lg:text-5xl">
          Um acompanhamento ético, humano e{" "}
          <span className="italic text-brand">baseado em evidências</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.1}>
            <div
              data-testid={`commitment-card-${i}`}
              className="h-full rounded-2xl bg-sand p-8 shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_20px_40px_rgba(45,51,47,0.09)]"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-brand/10">
                <item.icon className="h-6 w-6 text-brand" strokeWidth={1.6} />
              </div>
              <h3 className="mt-6 font-serif text-xl font-medium text-bark sm:text-2xl">
                {item.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-moss">{item.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
